export function getTotalPage(total: number): number {
  const pageLimit = 100;
  return Math.ceil(total / pageLimit);
}
